import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const ExamTransactionService = {
    getAllExamTransactionsByUser,
    getAllTransactions,
    manualExamPayment
};

async function getAllTransactions(node_id, limit, transaction_type, offset, search_term) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/exam-transactions/getAllExamTransactions/${node_id}/${limit}/${transaction_type}/${offset}?search_term=${search_term}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllExamTransactionsByUser(node_id, user_id, limit, transaction_type, offset, search_term) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    let user_id_string = user_id;
    if (Array.isArray(user_id)) {
        user_id_string = `[${user_id.join(",")}]`;
    }
    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/exam-transactions/getAllExamTransactionsByUser/${node_id}/${user_id_string}/${limit}/${transaction_type}/${offset}?search_term=${search_term}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function manualExamPayment(payment_obj) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: payment_obj,
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/exam-transactions/manual-payment`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}